const actiontype = {
  SET_CART: "SET_CART",

  SET_ACTIVE: "SET_ACTIVE",

  GET_CART: "GET_CART",

  LOGIN_USER: "LOGIN_USER",

  OPEN_POPOVER: "OPEN_POPOVER",

  CLOSE_POPOVER: "CLOSE_POPOVER",

  ADD_TO_CART: "ADD_TO_CART",

  SIGNUP_USER: "SIGNUP_USER",

  LOGOUT_USER: "LOGOUT_USER",

  SET_PRODUCTS: "SET_PRODUCTS",

  GET_WISHLIST: "GET_WISHLIST",

  SET_WISHLIST: "SET_WISHLIST",

  LOGIN_SUCCESS: "LOGIN_SUCCESS",

  LOGIN_FAILURE: "LOGIN_FAILURE",

  FETCH_PRODUCTS: "FETCH_PRODUCTS",

  LOADING_ACTION: "LOADING_ACTION",

  SET_CART_FILTER: "SET_CART_FILTER",

  ADD_TO_WISHLIST: "ADD_TO_WISHLIST",

  REMOVE_FROM_CART: "REMOVE_FROM_CART",

  REMOVE_FROM_WISHLIST: "REMOVE_FROM_WISHLIST",
};

export default actiontype;
